module.exports = __webpack_public_path__ + "static/media/logo_orka_krivky.bf18af10.svg";